<template>
  <b-modal
    id="modalTaskCommentNotification"
    ref="modalTaskCommentNotification"
    :no-enforce-focus="true"
    size="lg"
    @hidden="onHidden"
  >
    <div slot="modal-title">
      <i class="fas fa-comments text-primary mr-2" />
      {{ 'Comments' | translate }}
      <span v-if="task && (task.name || task.code)" class="text-muted ml-2">
        — {{ task.name || task.code }}
      </span>
    </div>

    <div v-if="loading" class="text-center my-3">
      <i class="fas fa-spinner fa-spin" />
    </div>
    <template v-else-if="task && task.id">
      <dl class="row mb-3 task-comment-notification-info">
        <dt class="col-sm-4">{{ 'Customer' | translate }}</dt>
        <dd class="col-sm-8 text-wrap">{{ task.customer_name || task.organization_name || '-' }}</dd>

        <dt class="col-sm-4">{{ 'Category' | translate }}</dt>
        <dd class="col-sm-8 text-wrap">{{ (task.category_detail && task.category_detail.name) || '-' }}</dd>

        <dt class="col-sm-4">{{ 'Priority' | translate }}</dt>
        <dd class="col-sm-8 text-wrap">{{ (task.priority_detail && task.priority_detail.name) || '-' }}</dd>

        <dt class="col-sm-4">{{ 'State' | translate }}</dt>
        <dd class="col-sm-8">
          <span
            v-if="task.state_name"
            class="badge"
            :style="{ backgroundColor: task.state_color || '#6c757d', color: '#fff' }"
          >
            {{ task.state_name }}
          </span>
          <span v-else>-</span>
        </dd>

        <dt class="col-sm-4">{{ 'Assignees' | translate }}</dt>
        <dd class="col-sm-8 text-wrap text-uppercase">{{ task.assignee_names || '-' }}</dd>

        <dt class="col-sm-4">{{ 'Due date' | translate }}</dt>
        <dd class="col-sm-8">{{ task.due_date || '-' }}</dd>
      </dl>

      <hr class="mt-0 mb-3" />

      <task-comment-section
        :task-id="task.id"
        :read-only="false"
      />
    </template>
    <p v-else class="text-muted text-center my-3">{{ 'No data' | translate }}</p>

    <div slot="modal-footer">
      <b-btn variant="default" @click="close">
        {{ 'Close' | translate }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_TYPES } from '@/pages/task/task/store'
import TaskCommentSection from '@/pages/task/task-comment/components/TaskCommentSection.vue'

export default {
  name: 'TaskCommentNotificationModal',
  components: {
    'task-comment-section': TaskCommentSection
  },
  props: {
    taskId: { required: true }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      task: TASK_TYPES.GENERIC.task.task.DETAIL.GETTERS.detail
    })
  },
  mounted () {
    this.$refs.modalTaskCommentNotification.show()
    this.fetchTask()
  },
  methods: {
    ...mapActions({
      retrieve: TASK_TYPES.GENERIC.task.task.DETAIL.ACTIONS.retrieve
    }),
    fetchTask () {
      this.loading = true
      this.retrieve({ id: this.taskId })
        .catch(() => {
          // errore già notificato dallo store (handleError)
        })
        .finally(() => {
          this.loading = false
        })
    },
    close () {
      this.$refs.modalTaskCommentNotification.hide()
    },
    onHidden () {
      this.$emit('close')
    }
  }
}
</script>
